export const REGEX_CLEAN_RUT = /[^0-9kK]+/g;
